/**
 * Sidebar state — shared between Sidebar and AppLayout.
 * Uses React Context for state sharing without external deps.
 */
import { createContext, useContext } from 'react';

export interface SidebarContextValue {
  collapsed: boolean;
  toggle: () => void;
}

export const SidebarContext = createContext<SidebarContextValue>({
  collapsed: false,
  toggle: () => {},
});

export function useSidebar() {
  return useContext(SidebarContext);
}
